export const LIST_PRODUCT_REQUEST = "LIST_PRODUCT_REQUEST";
export const LIST_PRODUCT_SUCCESS = "LIST_PRODUCT_SUCCESS";
export const LIST_PRODUCT_FAIL = "LIST_PRODUCT_FAIL";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";

export const SIMILAR_PRODUCTS_REQUEST = "SIMILAR_PRODUCTS_REQUEST";
export const SIMILAR_PRODUCTS_SUCCESS = "SIMILAR_PRODUCTS_SUCCESS";
export const SIMILAR_PRODUCTS_FAIL = "SIMILAR_PRODUCTS_FAIL";
